var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('ul',_vm._l((_vm.list),function(img,index){return _c('li',{key:index},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(img.src),expression:"img.src"}]})])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }